module.exports = __webpack_public_path__ + "static/media/btn_stop.d4e13c19.svg";